import { DEMO_NEXT_STEPS } from "../content";
import { DemoRequestForm } from "./DemoRequestForm";
import "./DemoSection.css";

/**
 * «Pide tu demo» (#demo), cierre de /organizador (spec B.3 fila 10 y B.4 §10).
 * Escritorio: texto y «Qué pasa después» a la izquierda, formulario blanco a
 * la derecha. Tablet y celular: título → formulario → «Qué pasa después»
 * (el mismo orden del DOM, así teclado y lector de pantalla siguen lo que se
 * ve).
 */
export function DemoSection() {
  return (
    <section id="demo" className="t123-section t123-section--navy t123-demo" aria-labelledby="demo-title">
      <div className="t123-shell t123-demo__grid">
        <div className="t123-demo__copy">
          <span className="t123-demo__kicker">Pide tu demo</span>
          <h2 id="demo-title" className="t123-h2">
            Te enseñamos Torneos123 y resolvemos tus dudas sobre tu torneo
          </h2>
          <p className="t123-lead">Déjanos tus datos y te contactamos por WhatsApp o correo para agendar. Sin costo.</p>
        </div>

        <div className="t123-demo__form">
          <DemoRequestForm />
        </div>

        <div className="t123-demo__next">
          <h3 className="t123-demo__next-title">Qué pasa después</h3>
          <ol className="t123-demo__steps">
            {DEMO_NEXT_STEPS.map((step, index) => (
              <li key={step}>
                <span className="t123-demo__num" aria-hidden="true">
                  {index + 1}
                </span>
                <span className="t123-demo__step-copy">{step}</span>
              </li>
            ))}
          </ol>
        </div>

        <span className="t123-demo__ball" aria-hidden="true">
          <span className="t123-footer-ball" />
        </span>
      </div>
    </section>
  );
}
